import { Button, Form } from "react-bootstrap"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import { SET_STANDARD, WEBSITE_SCANNING_PROCESS_PER_RESET, WEBSITE_URL } from "../../Actions/Types";
import { SendUserNewScanRequestEmailAPI } from "../../Api/GetUserEmailAPI";
interface PropType {
    isWhiteLabel?: boolean,
    startNewScan?: boolean,
}

// component to render user input form for scanning
const ScanURLFormComponents = (props:PropType) => {

    const {isWhiteLabel, startNewScan} = props

    const { websiteURL, scaningProcess, scaningProcessPer, pid, isFromScript, standard } = useSelector((store: StoreProptypes) => store);

    const { t } = useTranslation();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();


    const [websiteURLParam, setWebsiteURLParam] = useState("");

    const [userWebsiteURL, setUserWebsiteURL] = useState('');
    const [userWebsiteStandard, setUserWebsiteStandard] = useState(standard);
    const [websiteURLValidation, setWebsiteURLValidation] = useState(false);
    const [websiteURLValidationMsg, setWebsiteURLValidationMsg] = useState('');
    const inputRef = useRef<HTMLInputElement | null>(null)


    useEffect(() => {
        if (websiteURL) {
            setUserWebsiteURL(websiteURL);
        }
    }, [websiteURL]);

    useEffect(() => {
        dispatch({
            type: WEBSITE_SCANNING_PROCESS_PER_RESET,
            payload: 0,
        });
    }, [startNewScan])

    useEffect(() => {
        if (searchParams) {
            const temp = searchParams.get("website");
            if (temp) {
                setWebsiteURLParam(temp);
                setUserWebsiteURL(temp);
            }
        }
    }, [searchParams]);


    // function to validate website url
    const URLValidationEvent = (e: any) => {
        const inputValue = e.target.value;

        // check if input is empty
        if (inputValue === '') {
            setWebsiteURLValidation(true);
            setWebsiteURLValidationMsg(t("Please enter website URL."));
            setUserWebsiteURL(inputValue);
        } else {
            setWebsiteURLValidation(false);
            setWebsiteURLValidationMsg('')
            setUserWebsiteURL((inputValue.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')).trim('/'));
        }
    }

    // function to enter inp
    const enterInputValue = (e: any) => {
        const inputValue = e.target.value;

        if (inputValue === '' && websiteURL && websiteURL !== null) {
            setUserWebsiteURL(websiteURL);
            setWebsiteURLValidation(false);
            setWebsiteURLValidationMsg('')
        }
    }


    // function to handle form submit
    const HandleSubmit = (e: React.FormEvent) => {

        e.preventDefault();


        const httpRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,15}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/;

        // check if website url is empty
        if (userWebsiteURL === '') {
            setWebsiteURLValidation(true);
            setWebsiteURLValidationMsg(t("Please enter website URL."));
            inputRef.current?.focus()

        }
        // check if website url is valid
        else if (!(httpRegex.test(userWebsiteURL))) {
            setWebsiteURLValidation(true);
            setWebsiteURLValidationMsg(t("Please enter valid website URL."));
            inputRef.current?.focus()
        }
        else {
            if(isFromScript) {
                SendUserNewScanRequestEmailAPI(pid, userWebsiteURL || '').then(response => {
                    console.log('response: ', response);
                    // check if response data is available
                });
            }
            if (websiteURLParam) {
                navigate('/');
            }
            dispatch({
                type: WEBSITE_URL,
                payload: userWebsiteURL,
            });
            dispatch({
                type: SET_STANDARD,
                payload: userWebsiteStandard,
            });
        }
    }


    // function to handle standard dropdown change
    const handleStandard = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.currentTarget.value;
        setUserWebsiteStandard(value)
    }

    return (
        <>
            <div className='scan-url-form justify-content-center d-flex'>
                <Form onSubmit={(e) => HandleSubmit(e)}>
                    <div className='inline-form'>
                        <Form.Group controlId="website_url" className="mb-3 mb-md-0">
                            <Form.Control
                                className={`${websiteURLValidation ? `border-danger` : ``}`}
                                placeholder={t("Enter website URL")}
                                value={userWebsiteURL}
                                onChange={(e) => URLValidationEvent(e)}
                                onBlur={(e) => enterInputValue(e)}
                                ref={inputRef}
                                disabled={scaningProcess}
                                aria-label="Website"
                                required
                                aria-describedby={`website_description ${(!scaningProcessPer && websiteURLValidation) ? 'website_input_error' : ''}`}

                            />
                            {!isWhiteLabel && (
                                <Form.Text as='div' id="website_description" className="text-start">{t("For example: skynettechnologies.com")}</Form.Text>
                            )} 
                            {(scaningProcessPer && websiteURLValidation) ?
                                <>
                                <div className="text-danger mb-3" role="alert"> {t(websiteURLValidationMsg)}</div>
                                </>
                                : <></>
                            }
                        </Form.Group>
                        <Form.Group controlId="accessibility_standard">
                            <Form.Select aria-label={t("select-accessibility-standard")} value={userWebsiteStandard} onChange={(e) => handleStandard(e)}>
                                <option value="WCAG 2.0, 2.1 & 2.2" className="option-color">WCAG 2.0, 2.1 & 2.2</option>
                                <option value="California Unruh" className="option-color">California Unruh</option>
                                <option value="Ontario AODA" className="option-color">Ontario AODA</option>
                                <option value="UK Equality Act" className="option-color">UK Equality Act</option>
                                <option value="European EN 301 549" className="option-color">European EN 301 549</option>
                                <option value="Israeli Standard 5568" className="option-color">Israeli Standard 5568</option>
                                <option value="Australian DDA" className="option-color">Australian DDA</option>
                                <option value="ADA Title lll" className="option-color">ADA Title lll</option>
                                <option value="ATAG 2.0" className="option-color">ATAG 2.0</option>
                                <option value="Section 508" className="option-color">Section 508</option>
                                <option value="Canada ACA" className="option-color">Canada ACA</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                     {(!scaningProcessPer && websiteURLValidation && !startNewScan) ?
                        <div className="text-danger mb-3" id="website_input_error" role="alert">{t(websiteURLValidationMsg)}</div>
                        : <></>
                    }
                    <Button type="submit" size="lg" variant='primary' disabled={websiteURLValidation || scaningProcess}>
                        <span>{t("Start Scan")}</span>
                    </Button>

                </Form>

            </div>
                <div className="d-flex">
                    {(!scaningProcessPer && websiteURLValidation && startNewScan) ?
                        <div className="text-danger mb-3" style={{marginLeft:'14%'}} id="website_input_error" role="alert">{t(websiteURLValidationMsg)}</div>
                        : <></>
                    }
                </div>
        </>
    )
}

export default ScanURLFormComponents;
